"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayerType = void 0;
var PayerType;
(function (PayerType) {
    PayerType[PayerType["Unknown"] = 0] = "Unknown";
    // gesetzliche Krankenversicherung
    PayerType[PayerType["Statutory"] = 1] = "Statutory";
    // private Krankenversicherung
    PayerType[PayerType["Private"] = 2] = "Private";
    // Berufsgenossenschaft
    PayerType[PayerType["TradeAssociation"] = 3] = "TradeAssociation";
    // Selbstzahler
    PayerType[PayerType["Self"] = 4] = "Self";
    // Sonstige
    PayerType[PayerType["Other"] = 5] = "Other";
})(PayerType = exports.PayerType || (exports.PayerType = {}));
exports.default = PayerType;
